import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import AppContext from "./AppContext";
import gql from "graphql-tag";
import Login from "./Login";
import { Home } from "./pages";

const IS_LOGGED_IN = gql`
  query IsUserLoggedIn {
    isLoggedIn @client
  }
`;

function IsLoggedIn() {
  const { data } = useQuery(IS_LOGGED_IN);
  return data.isLoggedIn ? <AppContext /> : <Login />;
}

const AppCrash = () => {
  return (
    <Router>
      <Switch>0
        <Route path="/login" exact render={() => <IsLoggedIn />} />
        <Route path="/" exact render={() => <Home />} />
        <Redirect to="/" />
      </Switch>
    </Router>
  );
};

export default AppCrash;
